import $ from "jquery";

const $blocs = $(".testimonials-bloc")

const init_testimonials = () => {
    if ($blocs.length) {
        $(window).on('load resize', (e) => normalizeSlideHeights(e));
    }
}

const normalizeSlideHeights = (e) =>{
    console.log("normalizeSlideHeights");
    $blocs.each((index, el) => {
        const $items = $(el).find(".carousel-item");
        $items.css('min-height', 0).css('height', '');
        const maxHeight = Math.max.apply(null,
            $items.map(function(){
                console.log($(this).outerHeight());
                return $(this).outerHeight()
            }).get() );
        $items.css('min-height', maxHeight + 'px');
        $items.css('height', maxHeight + 'px');
    });
}


export {init_testimonials}